import styled from 'styled-components';
import { colors } from '@99designs/emu/settings';
import { IconStar2 } from '@99designs/icons';

const RatingStar = styled(IconStar2)`
    height: 16px;
    width: 16px;
`;

interface StarRatingProps {
    rating: number;
}

export default function StarRating({ rating }: StarRatingProps) {
    return (
        <>
            {Array(5)
                .fill(null)
                .map((_, index) => (
                    <RatingStar
                        key={index}
                        color={index >= rating ? colors.grey300 : colors.grey800}
                    />
                ))}
        </>
    );
}
